import React from "react";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Toolbar from "@material-ui/core/Toolbar";
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import logo from './twitter.png'
import { makeStyles } from "@material-ui/core/styles";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      {new Date().getFullYear()}
      {" "}
      {/*<a aria-label="Authors" href="https://github.com/burnpiro/wod-bike-dataset-generator#contributors-">Authors</a>*/}
      {"."}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  main: {
    minHeight: 'calc(100vh - 80px)',
  },
  logo: {
    maxHeight: 32,
    marginRight: theme.spacing(2)
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    width: '100vw',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 2),
  },
  currentUsageLabel: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    backgroundColor: 'rgba(255,255,255,0.3)'
  },
}));

export default function Layout({children, usage: {tweets}}) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="relative">
        <Toolbar>
          <img src={logo} alt="WRM Logo" className={classes.logo}/>
          <Typography variant="h6" color="inherit" noWrap>
            Twitter covid tags distribution
          </Typography>
          <div style={{display: 'flex', flex: 1}} />
        </Toolbar>
      </AppBar>
      <main className={classes.main}>
        { children }
      </main>
      {/* Footer */}
      <footer className={classes.footer}>
        <Copyright />
      </footer>
      {/* End footer */}
    </React.Fragment>
  );
}
